export default __webpack_public_path__ + "static/media/manage-network-resource.e5c98861.svg";